import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { BackTo } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import { Dashboard } from 'components/Layout';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { OrganizationType } from 'store/modules/auth/auth';
import { businessSectorsToApi } from 'store/modules/assistant/utils';
import Forms from 'components/Forms';
import api from 'api';

const { ROUTES, Redirect } = RouterProvider;
const { connect, selectors } = StoreProvider;

interface OrganizationDataProps extends RouteComponentProps<{ id: string }> {
  organization?: OrganizationType;
  isAdmin: boolean;
}

const OrganizationData = ({
  organization,
  location,
  isAdmin,
  match: { params },
  history,
}: OrganizationDataProps) => {
  const t = useFormatMessage();

  if (!params.id || !organization) {
    return <Redirect to={ROUTES.DASHBOARD} />;
  }

  const updateOrganization = (values: OrganizationType) =>
    api.resources.updateOrganization({
      id: organization.id,
      data: {
        ...values,
        business_sectors_ids: businessSectorsToApi(values.business_sectors),
      },
    });

  return (
    <Dashboard title={`About ${organization.name}`} location={location}>
      <BackTo onClick={() => history.push('/admin/organizations')}>
        {t('backTo.organizations', 'Back to Organizations')}
      </BackTo>
      <Forms.Organization
        initialValues={{
          ...organization,
          isAdmin,
        }}
        onSubmit={updateOrganization}
      />
    </Dashboard>
  );
};

export default connect((state, ownProps: OrganizationDataProps) => ({
  organization: selectors.organizationsSelectors.organizationById(
    ownProps.match.params.id
  )(state),
  isAdmin: selectors.authSelectors.isOrganizationAdmin(state),
}))(OrganizationData);
